import React from 'react';
// import axios from 'axios'; // Optional if you installed Axios


const JotFormComponent = () => {
  return (
    <div>
      {/* Paste the JotForm embed code here */}
      <iframe
        title="JotForm"
        src="https://form.jotform.com/70401156240946"
        width="100%"
        height="1015px"
        frameborder="0"
        scrolling="yes"
        style={{ border: 'none' }}
        allowfullscreen
      ></iframe>
    </div>
  );
};
export default JotFormComponent;